/* eslint-disable no-underscore-dangle */
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectLocale } from 'models/localization';
import InfoIcon from '@material-ui/icons/Info';
import { DesignCanvasLayer, Booth } from 'models/cms/booths';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import GuideContent from '../../components/BoothVideoCallGuideContent';
import StyledContainer, { ImageButton, StyledModal } from '../styled';
import { useNetworkingWidgetItem } from '../useNetworkingWidget';

const ElementContainer = styled(ImageButton) <{ disabled: boolean }>`
  width: 100%;
  height: 100%;
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
`;

const InfoBtn = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  color: #A2AAB3;

  & > svg {
    height: 18px;
    width: 18px;
  }
`;

interface ElementProps {
  layer: DesignCanvasLayer;
  booth: Booth;
  onElementClick: () => void;
}

const Element: React.FC<ElementProps> = ({
  layer,
  booth,
  onElementClick,
}: ElementProps) => {
  const locale = useSelector(selectLocale);
  const normalStateImageUrl: string = useMemo(() => findAvailableLocale(layer.normalStateImage, locale)?.originalImageUrl, [layer.normalStateImage, locale]);
  const hoverStateImageUrl: string = useMemo(() => findAvailableLocale(layer.hoverStateImage, locale)?.originalImageUrl || normalStateImageUrl, [layer.hoverStateImage, locale, normalStateImageUrl]);
  const actionType: string = useMemo(() => layer?.actionType, [layer?.actionType]);

  const {
    positionX, positionY, height, width,
  } = layer;

  const { isItemDisabled, handleItemClick } = useNetworkingWidgetItem(layer, booth);

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <StyledContainer width={width} height={height} positionX={positionX} positionY={positionY} onClick={!isItemDisabled ? onElementClick : null} disabled={isItemDisabled}>
      <ElementContainer
        disabled={isItemDisabled}
        normalStateImageUrl={normalStateImageUrl}
        hoverStateImageUrl={isItemDisabled ? normalStateImageUrl : hoverStateImageUrl}
        onClick={handleItemClick}
      />
      {
        actionType === 'VIDEO_CALL' && !isItemDisabled && (
          <InfoBtn>
            <InfoIcon onClick={handleOpen} />
            <StyledModal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-title"
              aria-describedby="modal-description"
            >
              <GuideContent
                handleClose={handleClose}
                isDesktop
              />
            </StyledModal>
          </InfoBtn>
        )
      }
    </StyledContainer>
  );
};

export default Element;
